import React, {Component} from 'react';
import {Grid, Row, Col, Form, FormGroup, ControlLabel} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import moment from "moment";
import BiletyService from "../../konfiguracja/biletyConfig/biletyApi/BiletyService";
import UrzadMiesieczneTable from "./components/UrzadMiesieczneTable";
import {TopInputDate} from "../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction} from "../../../componentsTopsa/buttons/TopButtons";
import DateAndTimeFormat from "../../../utilities/DateAndTimeFormat";
import UrzadService from "../UrzadService";

export default class UrzadBiletyMiesieczneContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bilety: [],
            dataOd: moment(),
            dataDo: moment(),
        };
    }

    componentDidMount() {
        this.pobierzBilety(
            DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
            DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo)
        )
    }

    pobierzBilety = (dataOd, dataDo) => {


        UrzadService.getpUrzadBiletyMiesieczne(dataOd, dataDo).then(function (response) {

            let bilety = Array.from(response.data, item => {
                return {
                    ...item,
                    waznyod_waznydo: item.wazny_od + " - " + item.wazny_do
                }
            });

            this.setState({bilety: bilety})
        }.bind(this))
    }

    onClickSzukaj = () => {
        let dataod = DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd);
        let datado = DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo);

        if (datado >= dataod) {
            this.pobierzBilety(dataod, datado)
        }
        else {
            alert('Data od nie może być wieksza od daty do!')
        }
    };

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'UrzadContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/urzad', text: 'Urząd'}, {addressUrl: '/urzad/miesieczne', text: 'Bilety miesięczne'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Form horizontal={true}>
                                <FormGroup style={{marginBottom: '0'}}>
                                    <Col md={2}>
                                        <ControlLabel>
                                            Data sprzedaży od <span className={'req'}>*</span>
                                        </ControlLabel>
                                        <TopInputDate onChange={(e) => this.setState({dataOd: e})} value={this.state.dataOd} withoutIcon={true} horizontal={true}/>
                                    </Col>
                                    <Col md={2}>
                                        <ControlLabel>
                                            Data sprzedaży do <span className={'req'}>*</span>
                                        </ControlLabel>
                                        <TopInputDate onChange={(e) => this.setState({dataDo: e})} value={this.state.dataDo} withoutIcon={true} horizontal={true}/>

                                    </Col>
                                    <Col md={3}>
                                        <div className={'add-label-margin'}></div>
                                        <TopButtonAction text={'Szukaj biletów'} iconType={'fa fa-search'} onClick={this.onClickSzukaj}
                                                         btnSize={'medium'}/>
                                    </Col>
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col sm={12}>
                            <UrzadMiesieczneTable data={this.state.bilety}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/bilety_miesieczne/UrzadBiletyMiesieczneContainer.js